import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "DokumenPensiun";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const dokumenPensiunCreate = "master/DokumenPensiun/create/";
export const dokumenPensiunList = "master/DokumenPensiun/list/";
export const dokumenPensiunDetail = "master/DokumenPensiun/detail/";
export const dokumenPensiunUpdate = "master/DokumenPensiun/update/";
export const dokumenPensiunInactive = "master/DokumenPensiun/inactive/";
export const dokumenPensiunActive = "master/DokumenPensiun/active/";
export const dokumenPensiunAll = "master/DokumenPensiun/get_province/";
export const dokumenPensiunListPension =
  "master/DokumenPensiun/list_type_pension/";
export const dokumenPensiunListStop = "master/DokumenPensiun/list_type_stop/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
